import React, { useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import withStyles from "react-jss";
import COLOURS from "util/colours";
import { H2, H3 } from "visual-components/util/texts";
import AppDispatcher from "../../dispatchers/app-dispatcher";
import ProfileDispatcher from "../../dispatchers/profile-dispatcher";
import SearchCard from "../../visual-components/shared/search-card";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9998,
  },
  modal: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "400px",
    maxWidth: "90%",
    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    zIndex: 9998,
  },
  error: {
    color: "red",
    fontSize: "1.5rem",
    marginTop: "4px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  input: {
    padding: "8px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "15px",
  },
  cancelBtn: {
    padding: "8px 16px",
    background: "#ccc",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  saveBtn: {
    padding: "8px 16px",
    background: "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  container: {
    padding: 40,
  },
  heading: {
    marginBottom: 24,
  },
  filterSection: {
    marginBottom: 24,
    padding: 16,
    border: `1px solid ${COLOURS.silver}`,
    borderRadius: 8,
    backgroundColor: "#fff",
  },
  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 24,
  },
  filterItem: {
    flex: "1 1 250px",
    minWidth: 220,
    display: "flex",
    flexDirection: "column",
    marginLeft: 12,
  },
  filterLabel: {
    marginBottom: 6,
    fontWeight: 500,
    fontSize: 14,
    color: "#333",
  },
  filterButton: {
    marginLeft: 16,
    backgroundColor: "transparent",
    border: "1px solid #007FFF",
    color: "#007FFF",
    padding: "6px 12px",
    borderRadius: 6,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#007FFF",
      color: "#fff",
    },
  },
  loader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 16,
    "& .spinner": {
      width: 24,
      height: 24,
      border: "4px solid #007FFF",
      borderTop: "4px solid transparent",
      borderRadius: "50%",
      animation: "$spin 1s linear infinite",
    },
  },
  tableWrapper: {
    marginTop: 16,
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: 14,
  },
  tableHeader: {
    backgroundColor: COLOURS.silver,
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  th: {
    padding: "12px 16px",
    textAlign: "left",
    borderBottom: "2px solid #ddd",
    fontWeight: 600,
    backgroundColor: "#f5f7fa",
    cursor: "pointer",
    userSelect: "none",
  },
  td: {
    padding: "12px 16px",
    borderBottom: "1px solid #eee",
  },
  tableRow: {
    "&:nth-child(even)": {
      backgroundColor: "#fafafa",
    },
    "&:hover": {
      backgroundColor: "#eaf4ff",
      transition: "0.2s",
    },
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
};
// Debounce utility (Option A)
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
function CSAdminSearchAccount(props) {
  const { classes } = props;
  const contentRef = useRef(null);
  const [brands, setbrands] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [account, setAccount] = useState({});
  const [keyword, setKeyword] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hidestatus, setHidestatus] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [formsubmit, setFormsubmit] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "status", direction: "desc" });
  const [brandSortConfig, setBrandSortConfig] = useState({ key: "status", direction: "desc" });
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  };
  const BrandhandleSort = (key) => {
    setBrandSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  };
  const handleViewClick = () => {
    setHidestatus((prev) => !prev);
    setTimeout(() => {
      contentRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 200);
  };
  const handleFormSubmit = async (data) => {
    data.user_id = account.user_id;
    setFormsubmit(true);
    const res = await fetch("/cs-accounts-update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const result = await res.json();
    if (result.success) {
      toastr.success("✅ Account updated successfully!", null, {
        timeOut: 2000,
        positionClass: "toast-bottom-center",
      });
      updateSearch(keyword);
      setIsOpen(false);
      setFormsubmit(false);
    } else {
      toastr.error(result.error || "❌ Failed to update account", null, {
        timeOut: 2000,
        positionClass: "toast-bottom-center",
      });
      setFormsubmit(false);
    }
  };
  const handleSearch = async (value) => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (value) params.append("keyword", value);

      const res = await fetch(`/cs-accounts?${params.toString()}`);
      const result = await res.json();
      const resultset = result.account;
      const brands = Object.values(
        resultset.reduce((acc, item) => {
          if (!acc[item.brand_id]) {
            acc[item.brand_id] = {
              brand_id: item.brand_id,
              accountname: item.accountname,
              website: item.website,
              belt: item.belt,
              country: item.country,
              trial_end: item.trial_end,
              entity_type: item.entity_type,
              dedicated_list_size: item.dedicated_list_size,
              disabled: item.disabled,
              owner_email: item.email,
            };
          }
          return acc;
        }, {}),
      );

      // Extract unique users
      const users = Object.values(
        resultset.reduce((acc, item) => {
          if (!acc[item.user_id]) {
            acc[item.user_id] = {
              user_id: item.user_id,
              email: item.email,
              first_name: item.first_name,
              last_name: item.last_name,
              deleted_at: item.deleted_at,
              uid: item.uid,
              brand_id: item.brand_id,
              accountname: item.accountname,
              last_login: item.last_login,
            };
          }
          return acc;
        }, {}),
      );
      setbrands(brands || []);
      setAccounts(users || []);
    } catch (err) {
      console.error("Failed to fetch accounts", err);
    } finally {
      setLoading(false);
    }
  };
  const debouncedSearch = useCallback(debounce(handleSearch, 1000), []);
  const updateSearch = (value) => {
    setKeyword(value);
    debouncedSearch(value);
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      first_name: account?.first_name || "",
      last_name: account?.last_name || "",
      email: account?.email || "",
    },
  });
  useEffect(() => {
    if (account) {
      reset({
        first_name: account.first_name || "",
        last_name: account.last_name || "",
        email: account.email || "",
      });
    }
  }, [account, reset]);
  const password = watch("password");
  const impersonate = (id, brand_id) => {
    ProfileDispatcher.impersonate(id, brand_id);
  };
  const confirmDisableBrand = (id) => {
    if (window.confirm("Are you sure you want to disable this brand?")) {
      AppDispatcher.http({
        url: `/cs-disable-brand/${id}`,
        method: "POST",
        success: () => {
          toastr.success("Brand Disabled successfully!", null, {
            timeOut: 3000,
            positionClass: "toast-bottom-center",
          });
          setbrands((prevBrands) =>
            prevBrands.map((brand) =>
              brand.brand_id === id ? { ...brand, disabled: true } : brand,
            ),
          );
        },
        error: (error) => {
          toastr.error(error.responseText, null, {
            timeOut: 3000,
            positionClass: "toast-bottom-center",
          });
        },
      });
    }
  };
  const confirmEnableBrand = (id) => {
    if (window.confirm("Are you sure you want to enable this brand?")) {
      AppDispatcher.http({
        url: `/cs-disable-brand/${id}?enable=true`,
        method: "POST",
        success: () => {
          toastr.success("Brand Enabled successfully!", null, {
            timeOut: 3000,
            positionClass: "toast-bottom-center",
          });
          setbrands((prevBrands) =>
            prevBrands.map((brand) =>
              brand.brand_id === id ? { ...brand, disabled: false } : brand,
            ),
          );
        },
        error: (error) => {
          toastr.error(error.responseText, null, {
            timeOut: 3000,
            positionClass: "toast-bottom-center",
          });
        },
      });
    }
  };
  const sortedAccounts = React.useMemo(() => {
    if (!accounts.length) return [];

    const sorted = [...accounts];
    const { key, direction } = sortConfig;

    sorted.sort((a, b) => {
      let valA = a[key];
      let valB = b[key];

      // Convert dates for user login
      if (key === "last_login") {
        valA = new Date(valA);
        valB = new Date(valB);
      }

      // Ensure case-insensitive sorting for strings
      if (typeof valA === "string") valA = valA.toLowerCase();
      if (typeof valB === "string") valB = valB.toLowerCase();

      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [accounts, sortConfig]);

  const sortedBrands = React.useMemo(() => {
    if (!brands.length) return [];

    const sorted = [...brands];
    const { key, direction } = brandSortConfig;

    sorted.sort((a, b) => {
      let valA = a[key];
      let valB = b[key];

      // Convert dates for user login
      if (key === "trial_end") {
        valA = new Date(valA);
        valB = new Date(valB);
      }

      // Ensure case-insensitive sorting for strings
      if (typeof valA === "string") valA = valA.toLowerCase();
      if (typeof valB === "string") valB = valB.toLowerCase();

      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    return sorted;
  }, [brands, brandSortConfig]);
  return (
    <div className={classes.container}>
      <div className={classes.heading}>
        <H2 azure>CS Admin - Account Modification </H2>
      </div>
      {/* Filter Section */}
      <div className={classes.filterSection}>
        <H3>Search Account</H3>
        <div className={classes.filterRow}>
          <div className={classes.filterItem}>
            <label className={classes.filterLabel}>Find accounts</label>
            <div className={classes.searchCard}>
              <SearchCard
                placeholder="Search for a user by email, name or brand name"
                value={keyword}
                onChange={updateSearch}
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: 32 }}>
        <H3>Search results:</H3>
        {loading && (
          <div className={classes.loader}>
            <div className="spinner" />
            <span>Searching...</span>
          </div>
        )}
        {!loading && (
          <>
            <div className={classes.filterRow} style={{ marginTop: 15 }}>
              <H3>Account Details:</H3>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                Brands: {brands.length}
                {sortedBrands.length > 0 && (
                  <span
                    style={{
                      display: "inline-block",
                      padding: "6px 12px",
                      marginRight: 12,
                      fontSize: 14,
                      marginTop: 10,
                      cursor: "pointer",
                      color: "#007bff",
                      border: "1px solid #007bff",
                      borderRadius: 6,
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#007bff";
                      e.target.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#007bff";
                    }}
                    onClick={handleViewClick}
                  >
                    View Associated Brands
                  </span>
                )}
              </div>
              <table
                className={classes.table}
                style={{ marginTop: 32, borderSpacing: "8px", borderCollapse: "separate" }}
              >
                <thead className={classes.tableHeader}>
                  <tr>
                    <th className={classes.th} onClick={() => handleSort("first_name")}>
                      First name{" "}
                      <span>
                        {sortConfig.key === "first_name"
                          ? sortConfig.direction === "asc"
                            ? "↑"
                            : "↓"
                          : "↕"}{" "}
                      </span>
                    </th>
                    <th className={classes.th} onClick={() => handleSort("last_name")}>
                      Last name{" "}
                      <span>
                        {sortConfig.key === "last_name"
                          ? sortConfig.direction === "asc"
                            ? "↑"
                            : "↓"
                          : "↕"}{" "}
                      </span>
                    </th>
                    <th className={classes.th} onClick={() => handleSort("email")}>
                      Email{" "}
                      <span>
                        {sortConfig.key === "email"
                          ? sortConfig.direction === "asc"
                            ? "↑"
                            : "↓"
                          : "↕"}{" "}
                      </span>
                    </th>
                    <th className={classes.th} onClick={() => handleSort("accountname")}>
                      Brand{" "}
                      <span>
                        {sortConfig.key === "accountname"
                          ? sortConfig.direction === "asc"
                            ? "↑"
                            : "↓"
                          : "↕"}{" "}
                      </span>
                    </th>
                    <th className={classes.th} onClick={() => handleSort("last_login")}>
                      Last Login{" "}
                      <span>
                        {sortConfig.key === "last_login"
                          ? sortConfig.direction === "asc"
                            ? "↑"
                            : "↓"
                          : "↕"}{" "}
                      </span>
                    </th>
                    <th className={classes.th} onClick={() => handleSort("status")}>
                      Status{" "}
                      <span>
                        {sortConfig.key === "status"
                          ? sortConfig.direction === "asc"
                            ? "↑"
                            : "↓"
                          : "↕"}{" "}
                      </span>
                    </th>
                    <th className={classes.th}>Action </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedAccounts.length === 0 ? (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ padding: "16px", textAlign: "center", color: "#999" }}
                      >
                        No Account found.
                      </td>
                    </tr>
                  ) : (
                    sortedAccounts.map((account) => (
                      <tr
                        key={`user_${account.user_id}`}
                        className={classes.tableRow}
                        style={{ backgroundColor: account.deleted_at ? "#f8d7da" : "#d4edda" }}
                      >
                        <td className={classes.td}>{account.first_name}</td>
                        <td className={classes.td}>{account.last_name}</td>
                        <td className={classes.td}>{account.email}</td>
                        <td className={classes.td}>{account.accountname}</td>
                        <td className={classes.td}>
                          {moment(account.last_login).format("YYYY-MM-DD hh:mm")}
                        </td>
                        <td className={classes.td}>
                          {account.deleted_at
                            ? `Deactive(${moment(account.deleted_at).format("YYYY-MM-DD")})`
                            : "Active"}
                        </td>
                        <td className={classes.td}>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setAccount(account);
                              setIsOpen(true);
                            }}
                          >
                            Edit
                          </a>{" "}
                          |{" "}
                          <a onClick={() => impersonate(account.uid, account.brand_id)}>
                            <span>Impersonate</span>
                          </a>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            {hidestatus && (
              <div ref={contentRef}>
                <div className={classes.filterRow} style={{ marginTop: 15 }}>
                  <H3>Brand list associated with account:</H3>
                </div>
                <table
                  className={classes.table}
                  style={{ marginTop: 32, borderSpacing: "8px", borderCollapse: "separate" }}
                >
                  <thead className={classes.tableHeader}>
                    <tr>
                      <th className={classes.th} onClick={() => BrandhandleSort("accountname")}>
                        Brand name{" "}
                        <span>
                          {brandSortConfig.key === "accountname"
                            ? brandSortConfig.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}{" "}
                        </span>
                      </th>
                      <th className={classes.th} onClick={() => BrandhandleSort("owner_email")}>
                        Owner Email{" "}
                        <span>
                          {brandSortConfig.key === "owner_email"
                            ? brandSortConfig.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}{" "}
                        </span>
                      </th>
                      <th className={classes.th} onClick={() => BrandhandleSort("website")}>
                        Website{" "}
                        <span>
                          {brandSortConfig.key === "website"
                            ? brandSortConfig.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}{" "}
                        </span>
                      </th>
                      <th className={classes.th} onClick={() => BrandhandleSort("belt")}>
                        Belt{" "}
                        <span>
                          {brandSortConfig.key === "belt"
                            ? brandSortConfig.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}{" "}
                        </span>
                      </th>
                      <th className={classes.th} onClick={() => BrandhandleSort("country")}>
                        Country{" "}
                        <span>
                          {brandSortConfig.key === "country"
                            ? brandSortConfig.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}{" "}
                        </span>
                      </th>
                      <th className={classes.th} onClick={() => BrandhandleSort("trial_end")}>
                        Trial end date{" "}
                        <span>
                          {brandSortConfig.key === "trial_end"
                            ? brandSortConfig.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}{" "}
                        </span>
                      </th>
                      <th className={classes.th} onClick={() => BrandhandleSort("entity_type")}>
                        Entity type{" "}
                        <span>
                          {brandSortConfig.key === "entity_type"
                            ? brandSortConfig.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}{" "}
                        </span>
                      </th>
                      <th
                        className={classes.th}
                        onClick={() => BrandhandleSort("dedicated_list_size")}
                      >
                        List size{" "}
                        <span>
                          {brandSortConfig.key === "dedicated_list_size"
                            ? brandSortConfig.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}{" "}
                        </span>
                      </th>
                      <th className={classes.th} onClick={() => BrandhandleSort("disabled")}>
                        Status{" "}
                        <span>
                          {brandSortConfig.key === "disabled"
                            ? brandSortConfig.direction === "asc"
                              ? "↑"
                              : "↓"
                            : "↕"}{" "}
                        </span>
                      </th>
                      <th className={classes.th}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedBrands.length === 0 ? (
                      <tr>
                        <td
                          colSpan={5}
                          style={{ padding: "16px", textAlign: "center", color: "#999" }}
                        >
                          No Associated Brands found.
                        </td>
                      </tr>
                    ) : (
                      sortedBrands.map((acc) => {
                        return (
                          <tr
                            key={acc.brand_id}
                            className={classes.tableRow}
                            style={{ backgroundColor: acc.disabled ? "#f8d7da" : "#d4edda" }}
                          >
                            <td
                              className={classes.td}
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => window.open(`/app/explore/brands/${acc.brand_id}`)}
                            >
                              {acc.accountname}
                            </td>
                            <td className={classes.td}>{acc.owner_email}</td>
                            <td className={classes.td}>{acc.website}</td>
                            <td className={classes.td}>{acc.belt}</td>
                            <td className={classes.td}>{acc.country}</td>
                            <td className={classes.td}>
                              {moment(acc.trial_end).format("YYYY-MM-DD")}
                            </td>
                            <td className={classes.td}>{acc.entity_type}</td>
                            <td className={classes.td}>{acc.dedicated_list_size}</td>
                            <td className={classes.td}>{acc.disabled ? "Deactive" : "Active"}</td>
                            <td className={classes.td}>
                              {!acc.disabled ? (
                                <a onClick={() => confirmDisableBrand(acc.brand_id)}>
                                  <span>Disable</span>
                                </a>
                              ) : (
                                <a onClick={() => confirmEnableBrand(acc.brand_id)}>
                                  <span>Enable</span>
                                </a>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
      {isOpen && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2>Edit User</h2>
            <form style={styles.form} onSubmit={handleSubmit(handleFormSubmit)}>
              <label>Email</label>
              <input
                type="email"
                placeholder="Enter email"
                defaultValue={accounts[0].email}
                style={styles.input}
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Invalid email format",
                  },
                })}
              />
              {errors.email && <p style={styles.error}>{errors.email.message}</p>}

              <label>Password</label>
              <input
                type="password"
                placeholder="Enter password"
                style={styles.input}
                {...register("password", {
                  validate: (value) =>
                    !value || value.length >= 6 || "Password must be at least 6 characters",
                })}
              />
              {errors.password && <p style={styles.error}>{errors.password.message}</p>}
              <label>Confirm Password</label>
              <input
                type="password"
                placeholder="Confirm password"
                style={styles.input}
                {...register("confirmPassword", {
                  validate: (value) => !password || value === password || "Passwords do not match",
                })}
              />
              {errors.confirmPassword && (
                <p style={styles.error}>{errors.confirmPassword.message}</p>
              )}
              <label>First Name</label>
              <input
                type="text"
                placeholder="Enter first name"
                style={styles.input}
                {...register("first_name", {
                  required: "First name is required",
                  pattern: {
                    value: /^[A-Za-z]+$/,
                    message: "Only letters allowed",
                  },
                })}
              />
              {errors.first_name && <p style={styles.error}>{errors.first_name.message}</p>}

              <label>Last Name</label>
              <input
                type="text"
                placeholder="Enter last name"
                style={styles.input}
                {...register("last_name", {
                  required: "Last name is required",
                  pattern: {
                    value: /^[A-Za-z]+$/,
                    message: "Only letters allowed",
                  },
                })}
              />
              {errors.last_name && <p style={styles.error}>{errors.last_name.message}</p>}

              <div style={styles.actions}>
                <button type="button" onClick={() => setIsOpen(false)} style={styles.cancelBtn}>
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    ...styles.saveBtn,
                    opacity: formsubmit ? 0.6 : 1,
                    cursor: formsubmit ? "not-allowed" : "pointer",
                  }}
                  disabled={formsubmit}
                >
                  {formsubmit ? "Processing..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

CSAdminSearchAccount.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CSAdminSearchAccount);
